import { ReactNode } from 'react';
import { IconArrowLeft, IconClose } from '../components/icons';

/*
 * Шапка окна, панели и экрана стопки (дизайн-система 3.12 PanelHead).
 * На десктопе справа крестик, на телефоне слева стрелка «назад» (какая
 * кнопка видна, решает CSS по ширине экрана). Обе зовут один и тот же onBack.
 */
export function PanelHead({
  title,
  sub,
  onBack,
  action,
}: {
  title: ReactNode;
  sub?: ReactNode;
  onBack: () => void;
  action?: ReactNode;
}) {
  return (
    <div className="panel-head">
      <button className="ibtn outline sm back" onClick={onBack} title="Назад" aria-label="Назад">
        <IconArrowLeft />
      </button>
      <div className="title">
        {title}
        {sub ? <i>{sub}</i> : null}
      </div>
      {action}
      <button className="ibtn round close" onClick={onBack} title="Закрыть" aria-label="Закрыть">
        <IconClose />
      </button>
    </div>
  );
}
